import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery } from "@/redux/baseQuery";
import { transformAccounts } from "./helpers";
import { GetAccountsResponse, UpdatePasswordParams, AttachClientToProviderParams } from "./types";

export const accountApi = createApi({
  reducerPath: "accountApi",
  baseQuery,
  endpoints: (builder) => ({
    getAccounts: builder.query<GetAccountsResponse, void>({
      query: () => "/v3/account-management",
      transformResponse: transformAccounts,
      providesTags: ["Account"],
    }),
    updatePassword: builder.mutation<void, UpdatePasswordParams>({
      query: ({ id, ...body }) => ({
        url: `/v3/account-management/${id}/profile/password`,
        method: "PUT",
        body,
      }),
    }),
    attachClientToProvider: builder.mutation<void, AttachClientToProviderParams>({
      query: ({ clientId, providerId }) => ({
        url: `/v3/account-management/${clientId}/providers/${providerId}/application/attach`,
        method: "POST",
        body: { role: "client" },
      }),
    }),
  }),
  tagTypes: ["Account"],
});

export const { useLazyGetAccountsQuery, useUpdatePasswordMutation, useAttachClientToProviderMutation } = accountApi;
